import script from "./iconBand.vue?vue&type=script&lang=js"
export * from "./iconBand.vue?vue&type=script&lang=js"

import "./iconBand.vue?vue&type=style&index=0&id=1245312c&lang=scss"

const __exports__ = script;

export default __exports__